import Notification from 'flarum/forum/components/Notification';
import app from 'flarum/forum/app';

export default class MentorGraduatedNotification extends Notification {
  icon() {
    return 'fas fa-graduation-cap';
  }

  href() {
    const user = app.session.user;
    return user ? app.route('user.taroMentors', { username: user.slug() }) : '#';
  }

  content() {
    return '恭喜！你的等级已超过导师的指导范围，已自动毕业';
  }

  excerpt() {
    return '你可以选择更高等级的导师继续学习';
  }
}
